module.exports = __webpack_public_path__ + "img/arrows-right.9d50d526.svg";